import * as React from 'react'

import { InfoBoxItem, InfoBoxItemProps } from './InfoBoxItem'
import { InfoBoxesWrapper } from './style'

export interface InfoBoxesProps {
  items: InfoBoxItemProps[]
}

export const InfoBoxes = (props: InfoBoxesProps) => {
  return (
    <InfoBoxesWrapper>
      {props.items.map((data, index) => {
        return <InfoBoxItem key={index} {...data} />
      })}
    </InfoBoxesWrapper>
  )
}
